import { useState } from "react";
import { COPY } from "../content/copy";
import { verifySharePassword } from "../lib/auth";
import { navigate } from "../lib/router";
import { TurnstileWidget } from "./TurnstileWidget";

export function ShareForm({ slug }: { slug: string }) {
  const [password, setPassword] = useState("");
  const [turnstile, setTurnstile] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [turnstileFailed, setTurnstileFailed] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!turnstile || busy) return;
    setBusy(true);
    setError(null);
    const r = await verifySharePassword({ slug, password, turnstile });
    setBusy(false);
    if (r.ok) {
      navigate("/");
      return;
    }
    switch (r.error) {
      case "bad_password":
        setError(COPY.landing.errors.badPassword.text);
        break;
      case "rate_limited": {
        const mins = Math.max(1, Math.ceil((r.retryAfterSeconds ?? 60) / 60));
        setError(COPY.landing.errors.rateLimited.text.replace("{minutes}", String(mins)));
        break;
      }
      case "verification_unavailable":
        setError(COPY.landing.errors.verificationUnavailable.text);
        break;
      case "expired":
        navigate("/expired", true);
        return;
      case "internal":
      default:
        setError(COPY.landing.errors.internal.text);
    }
  }

  return (
    <form className="landing__form" onSubmit={submit}>
      <h1 className="landing__heading">{COPY.landing.heading.text}</h1>
      <input
        type="password"
        className="landing__input"
        placeholder={COPY.landing.prompt.text}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        autoFocus
        autoComplete="off"
        spellCheck={false}
      />
      <TurnstileWidget
        onToken={setTurnstile}
        onError={() => {
          setTurnstileFailed(true);
          setError(COPY.landing.errors.verificationUnavailable.text);
        }}
      />
      <button
        type="submit"
        className="landing__submit"
        disabled={!turnstile || busy || turnstileFailed || password.length === 0}
      >
        {busy ? COPY.landing.verifying.text : COPY.landing.submit.text}
      </button>
      <p className="landing__error" role="alert">
        {error ?? " "}
      </p>
    </form>
  );
}
